import React from 'react';
import { Briefcase as BriefcaseIcon } from './Generic/Icons';
import SimpleCard from './Generic/SimpleCard';
import { Link } from './Generic/Link';
import RoleStatus from '../Constants/RoleStatus.json';
import ApplicationStatus from '../Constants/ApplicationStatus.json';
import useRole from '../Provider/TableContext/RoleContext';

export default function JobApplicationAcceptancePanel(props) {
    const { roles } = useRole();
    const applicationPercentage = React.useMemo(() => {
        let applicationCount = 0, submittedRoleCount = 0, offeredRoles = 0;
        if (Array.isArray(roles)) roles.forEach(role => {
            if (role.mcb_rolestatus === RoleStatus.Applying) {
                applicationCount++;
                if (role.mcb_applicationstatus >= ApplicationStatus["Submitting Application"]) {
                    submittedRoleCount++;
                    if (role.mcb_applicationstatus >= ApplicationStatus["Offered"]) {
                        offeredRoles++;
                    }
                }
            }
        });

        if (applicationCount === 0 || submittedRoleCount === 0) return '0';
        else return  Math.round((offeredRoles / submittedRoleCount) * 100);

        
    }, [roles]);
    
    return (
        <SimpleCard
            Icon={BriefcaseIcon}
            backgroundColor="var(--mo-primary)" 
            {...props}
        >
            <div className='d-flex flex-row flex-nowrap justify-content-between align-items-center flex-grow-1'>
                <div className="flex-grow-1"><strong
                        className="rounded-pill px-2 py-1 mx-1"
                        style={{backgroundColor: "var(--mo-gray-400)", fontSize: "0.89em"}}
                    >{applicationPercentage}%</strong><span>of your submitted applications<br/> have resulted in a job offer.</span></div>
                <Link className="btn btn-primary" to="/applying-job-setup">Add Job Application</Link>
            </div>
            
        </SimpleCard>
    );
}